import axios from "axios";

const oneDayCache = 86400;

export const getCities = async () => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/location/city`;

  const response = await fetch(url, {
    next: {
      revalidate: oneDayCache,
    },
    cache: "force-cache",
  });

  if (!response.ok) {
    throw new Error("Şehir Bilgileri Alınamadı");
  }

  return response.json();
};

export const getDistricts = async (cityId) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/location/city/${cityId}/district`;
  const response = await axios.get(url);
  return response.data;
};

export const getLocalitiesAndTowns = async (districtId) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/location/district/${districtId}/locality-town`;
  const response = await axios.get(url);
  return response.data;
};

export const getBounds = async (locationId) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/geolocation/locations`;
  const response = await axios.post(
    url,
    {
      application: "desktop-web",
      options: {
        fields: ["bounds"],
      },
      params: {
        id: locationId,
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const getLocationBounds = async (ids) => {
  const url = `${window.env.EJ_APPS_LOCATION_API_HOSTNAME}/location/v1/location/bounds`;
  const response = await axios.post(
    url,
    {
      application: "desktop-web",
      ids,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const getListOfRelativeLocations = async (locationIds) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/geolocation/list-of-relative-locations`;
  const response = await axios.post(
    url,
    {
      application: "desktop-web",
      ids: locationIds,
      options: {
        compress: false,
        fields: ["id", "name", "type", "bounds", "city", "district", "town", "slug"],
        extraFieldsByLocationType: {
          city: ["geometryLow"],
          district: ["geometryMid"],
          town: ["geometryHigh"],
        },
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const getPolygonBounds = async (locationIds, isRegion) => {
  let url = `${window.env.EJ_APPS_LOCATION_API_HOSTNAME}/location/v1/location/relative-locations`;
  if (locationIds) {
    const idKeyword = isRegion ? "regionId" : "locationIds";
    url = `${window.env.EJ_APPS_LOCATION_API_HOSTNAME}/location/v1/location/relative-locations?${idKeyword}=${locationIds}`;
  }

  const response = await axios.get(url);
  return response.data;
};

export const getPoisByTownId = async (townId, categoryIds) => {
  const url = `${window.env.EJ_APPS_LOCATION_API_HOSTNAME}/location/v1/poi/pois-by-town`;
  const response = await axios.post(
    url,
    {
      townId,
      categoryIds,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const getSearchCriteria = async (path) => {
  const url = `${window.env.EJ_APPS_SEARCH_API}/search/v1/parser${path}`;
  const response = await axios.get(url);
  return response.data;
};
